'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var ObjectHelper = require('../../common/ObjectHelper.js');
var MenuItem = require('../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var OtherIndustrySelect =
/*#__PURE__*/
function (_PureComponent) {
  inherits(OtherIndustrySelect, _PureComponent);

  function OtherIndustrySelect() {
    classCallCheck(this, OtherIndustrySelect);

    return possibleConstructorReturn(this, getPrototypeOf(OtherIndustrySelect).apply(this, arguments));
  }

  createClass(OtherIndustrySelect, [{
    key: "menuOptions",
    value: function menuOptions() {
      return this.props.other_service_categories.map(function (industry) {
        return React__default["default"].createElement(MenuItem["default"], {
          value: industry.id,
          key: industry.id
        }, industry.name);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selectedIndustry = _this$props.selectedIndustry,
          onIndustrySelected = _this$props.onIndustrySelected,
          selectOpen = _this$props.selectOpen,
          onSelectOpen = _this$props.onSelectOpen,
          onSelectClose = _this$props.onSelectClose,
          other_service_categories = _this$props.other_service_categories;
      return React__default["default"].createElement(TextField["default"], {
        id: "otherIndustry",
        variant: "filled",
        select: true,
        value: selectedIndustry.id || '',
        children: this.menuOptions(),
        label: "Select your specific industry",
        onChange: function onChange(e) {
          var newIndustry = other_service_categories.find(function (industry) {
            return industry.id === e.target.value;
          });

          if (ObjectHelper.isPresent(newIndustry)) {
            onIndustrySelected(newIndustry);
          }
        },
        fullWidth: true,
        SelectProps: {
          open: selectOpen,
          onClose: onSelectClose,
          onOpen: onSelectOpen
        }
      });
    }
  }]);

  return OtherIndustrySelect;
}(React.PureComponent);
OtherIndustrySelect.defaultProps = {
  other_service_categories: [],
  selectedIndustry: {},
  onIndustrySelected: function onIndustrySelected() {},
  selectOpen: false,
  onSelectClose: function onSelectClose() {},
  onSelectOpen: function onSelectOpen() {}
};

module.exports = OtherIndustrySelect;
